module.exports = __webpack_public_path__ + "img/allergy-free-air.ee7e787c.png";